// ArChat Debug Logger
// Created: 03-04-2026 20:56:27
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Logger desactivado en runtime para evitar ruido de depuración.
 */
export const debugLog = () => {};
export const debugError = () => {};
